import { render, staticRenderFns } from "./AlternativeInformation.vue?vue&type=template&id=ef1a265e&scoped=true"
import script from "./AlternativeInformation.vue?vue&type=script&lang=js"
export * from "./AlternativeInformation.vue?vue&type=script&lang=js"
import style0 from "./AlternativeInformation.vue?vue&type=style&index=0&id=ef1a265e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1a265e",
  null
  
)

export default component.exports